import React, { useEffect, useRef, useState } from 'react';
import styles from './StoryboardAssistantModal.module.scss';
import { useTranslation } from 'react-i18next';
import CloseButton from '../../../../components/CloseButton/CloseButton';
import { DebounceInput } from 'react-debounce-input';
import { CustomButton } from '../../../../components/Button/Button';
import SelectOption from '../../../../components/SelectOption/SelectOption';
const MIN_ASSISTANT_REQUEST_LENGTH = 10;

const StoryboardAssistantModal = ({ onClose, onRequest }) => {
  const [assistantInput, setAssistantInput] = useState('');

  const { t, i18n } = useTranslation();

  const inputRef = useRef();

  const defaultPresetSelected = {
    id: t('storyboard.editor.assistant.presets.default'),
    name: t('storyboard.editor.assistant.preset_values.default'),
    value: t('storyboard.editor.assistant.preset_values.default')
  };

  const getEnglishTranslation = i18n.getFixedT('en');

  const isGerman = i18n.language === 'de';

  const predefinedRequests = {
    [t('storyboard.editor.assistant.presets.change_number_of_clips')]: isGerman
      ? getEnglishTranslation('storyboard.editor.assistant.preset_values.change_number_of_clips')
      : t('storyboard.editor.assistant.preset_values.change_number_of_clips'),
    [t('storyboard.editor.assistant.presets.rewrite_clips')]: isGerman
      ? getEnglishTranslation('storyboard.editor.assistant.preset_values.rewrite_clips')
      : t('storyboard.editor.assistant.preset_values.rewrite_clips'),
    [t('storyboard.editor.assistant.presets.add_more_dialogue')]: isGerman
      ? getEnglishTranslation('storyboard.editor.assistant.preset_values.add_more_dialogue')
      : t('storyboard.editor.assistant.preset_values.add_more_dialogue'),
    [t('storyboard.editor.assistant.presets.summarize_dialogue')]: isGerman
      ? getEnglishTranslation('storyboard.editor.assistant.preset_values.summarize_dialogue')
      : t('storyboard.editor.assistant.preset_values.summarize_dialogue'),
    [t('storyboard.editor.assistant.presets.add_call_to_action')]: isGerman
      ? getEnglishTranslation('storyboard.editor.assistant.preset_values.add_call_to_action')
      : t('storyboard.editor.assistant.preset_values.add_call_to_action'),
    [t('storyboard.editor.assistant.presets.change_location')]: isGerman
      ? getEnglishTranslation('storyboard.editor.assistant.preset_values.change_location')
      : t('storyboard.editor.assistant.preset_values.change_location'),
    [t('storyboard.editor.assistant.presets.translate_storyboard')]: isGerman
      ? getEnglishTranslation('storyboard.editor.assistant.preset_values.translate_storyboard')
      : t('storyboard.editor.assistant.preset_values.translate_storyboard')
  };

  const handleInput = e => {
    setAssistantInput(e.target.value);
  };

  const handlePredefinedSelect = (e) => {
    setAssistantInput(predefinedRequests[e.target.value]);
  };

  useEffect(() => {
    inputRef?.current && inputRef?.current?.focus();
  }, [inputRef?.current]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>{t('storyboard.editor.assistant.dialog.title')}</h1>
        <CloseButton onClose={onClose} />
      </div>
      <p className={styles.description}>{t('storyboard.editor.assistant.description')}</p>
      <div className={styles.inputContainer}>
        <div className={styles.inputHeader}>
          <SelectOption
            parentRef={inputRef}
            title={t('storyboard.editor.assistant.select_preset')}
            currentlySelected={defaultPresetSelected}
            options={Object.keys(predefinedRequests).map(key => ({
              id: key,
              name: key,
              value: predefinedRequests[key]
            }))}
            onSelect={(option) => handlePredefinedSelect({ target: { value: option.id } })}
            currentInputClassName={styles.currentSelect}
          />
        </div>
        <p className={styles.label}>{t('storyboard.editor.assistant.input_label')}</p>
        <DebounceInput
          inputRef={inputRef}
          element={'textarea'}
          value={assistantInput}
          placeholder={t('storyboard.editor.assistant.placeholder')}
          onChange={handleInput}
          className={styles.textarea}
          autoFocus={true}
        />
      </div>
      <CustomButton
        disabled={assistantInput.length < MIN_ASSISTANT_REQUEST_LENGTH}
        className={styles.sendBtn}
        label={t('storyboard.editor.assistant.send_request')}
        variant="primary"
        onClick={() => onRequest(assistantInput)}
      />
    </div>
  );
};

export default StoryboardAssistantModal;
